window.$ = window.jQuery;

$(document).ready(function () {
    $('footer h6').each(function (index, item) {
        var $el = $(this);

        if (true == $($el).next().is('ul')) {
            $el.addClass('js-footer-header');
        }
    });

    $('footer h6').on('click', function () {
        $(this).next().toggle();
    });

    $('.js-show-mobile-menu').on('click', function () {
        const menu = document.getElementById('myNav');
        if (menu.hidden) {
            menu.hidden = false;
            // Establish the closed width before starting the first transition.
            menu.getBoundingClientRect();
        }
        $(menu).css("width","100%");
        $("body").css("overflow", "hidden");
    });

    $('.closebtn').on('click', function () {
        $('#myNav').css("width","0%");
        $("body").css("overflow", "visible");
    });

    $('.js-show-mobile-menu-more').on('click', function () {
        const isActive = $('.main-menu__sub-menu').hasClass('js-menu-active');
        if (isActive) {
            $('.main-menu__sub-menu').removeClass('js-menu-active');
            $('.main-menu__sub-menu').slideUp();
        } else {
            $('.main-menu__sub-menu').addClass('js-menu-active');
            $('.main-menu__sub-menu').slideDown();
        }
    });

    $('.js-show-mobile-menu-tours').on('click', function () {
        const isActive = $('.main-menu__sub-menu-tours').hasClass('js-menu-active');
        if (isActive) {
            $('.main-menu__sub-menu-tours').removeClass('js-menu-active');
            $('.main-menu__sub-menu-tours').slideUp();
        } else {
            $('.main-menu__sub-menu-tours').addClass('js-menu-active');
            $('.main-menu__sub-menu-tours').slideDown();
        }
    });

    $('.js-show-mobile-menu-transfers').on('click', function () {
        const isActive = $('.main-menu__sub-menu-transfers').hasClass('js-menu-active');
        if (isActive) {
            $('.main-menu__sub-menu-transfers').removeClass('js-menu-active');
            $('.main-menu__sub-menu-transfers').slideUp();
        } else {
            $('.main-menu__sub-menu-transfers').addClass('js-menu-active');
            $('.main-menu__sub-menu-transfers').slideDown();
        }
    });

    $('.mobile__menu-item').on('click', function () {
        $('.mobile__help-menu-container').slideUp();
    });


    $('.mobile-header__language-btn').on('click', function () {
        $('.mobile-languages ul.languages').toggle();
    });

    $('.js-contact-scroll-down').click(function () {
        $('html, body').animate({
            scrollTop: $(".page-section-content").offset().top - 50
        }, 1000);
        return false;
    });

    $.each($('textarea'), function () {
        var offset = this.offsetHeight - this.clientHeight;

        var resizeTextarea = function (el) {
            $(el).css('height', 'auto').css('height', el.scrollHeight + offset + 50);
        };
        $(this).on('keyup input', function () {
            resizeTextarea(this);
        });
    });

    $('.contact__item').on('click', function () {
        return $(window).width() < 1000;
    })

    $('h4[content_id]').on('click', function(e) {
        $('#'+$(this).attr('content_id')).toggle();
        if($(this).find("i").hasClass('fa-angle-double-down')){
            $(this).find("i").removeClass('fa-angle-double-down');
            $(this).find("i").addClass('fa-angle-double-up');
        }else {
            $(this).find("i").removeClass('fa-angle-double-up');
            $(this).find("i").addClass('fa-angle-double-down');
        }
    });

    let libsLoaded = false;

    $("body,html").one("touchstart touchmove scroll mousemove mousedown DOMMouseScroll mousewheel keyup", function(e){
        if(libsLoaded){
            return true;
        }

        $(".first-slider-image").hide();
        $(".revslidercolumn").show();
        $(".revslidercolumn").css("height", "auto");

        (function(d, s, id) {
            var js, fjs = d.getElementsByTagName(s)[0];
            if (d.getElementById(id)) return;
            js = d.createElement(s); js.id = id;
            js.src = "//connect.facebook.net/en_US/sdk.js#xfbml=1&version=v2.7";
            fjs.parentNode.insertBefore(js, fjs);
        }(document, 'script', 'facebook-jssdk'));

        (function(d, s, id) {
            var js, fjs = d.getElementsByTagName(s)[0];
            if (d.getElementById(id)) return;
            js = d.createElement(s); js.id = id;
            js.async = false;
            js.src = 'https://connect.facebook.net/en_US/sdk/xfbml.customerchat' +
                '.js#xfbml=1&alignment=’left’&version=v2.12&autoLogAppEvents=1&greeting_dialog_display=’show’';
            fjs.parentNode.insertBefore(js, fjs);
        }(document, 'script', 'facebook-jssdk'));

        libsLoaded = true;

        let lazyLoadCompleteEvent = new Event('lazyLoadCompleteLoaded');
        document.dispatchEvent(lazyLoadCompleteEvent);
    });

});
